<template>
  <div class="StudentProfile">

    <h1 class="m-label" style="margin: 0">
      生徒基本情報
    </h1>

    <template v-if="student.id == edit_id.student_id">
      <form @submit.prevent="patchStudent(student)">
        <div class="m-box__inner">
          <table class="m-detail">
            <template v-if="!valid">
              <tr>
                <th>エラー</th>
                <td class="errors"><div>{{errors}}が入力されていません</div></td>
              </tr>
            </template>
            <!-- <tr> -->
            <!--   <th>ID</th> -->
            <!--   <td><div class="calc">{{student.id}}</div></td> -->
            <!-- </tr> -->
            <!-- <tr> -->
            <!--   <th>family_id</th> -->
            <!--   <td><div class="calc">{{student.family_id}}</div></td> -->
            <!-- </tr> -->
            <!-- <tr> -->
            <!--   <th>user_id</th> -->
            <!--   <td><div class="calc">{{student.user_id}}</div></td> -->
            <!-- </tr> -->
            <tr>
              <th>状態</th>
              <td><multiselect v-model="watch.state" :options="state" label="name" :searchable="false" :show-labels="false" placeholder="状態"></multiselect></td>
            </tr>
            <tr>
              <th>名前</th>
              <td><input type="text" class="name_w" v-model="student.f_name" @keypress.self.prevent.13><input type="text" class="name_w" v-model="student.l_name" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th class="req">かな</th>
              <td><input type="text" required class="name_w" v-model="student.f_name_kana" @keypress.self.prevent.13><input type="text" required class="name_w" v-model="student.l_name_kana" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th class="req">性別</th>
              <td><multiselect v-model="watch.gender" :options="gender" label="name" :searchable="false" :show-labels="false" placeholder="性別"></multiselect></td>
            </tr>
            <tr>
              <th class="req">生年月日</th>
              <td><input type="text" required maxlength="10" minlength="10" v-model="student.birthday" placeholder="生年月日" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>年齢</th>
              <td><div class="calc">{{calcAge}}</div></td>
            </tr>
            <tr>
              <th>公/国/私</th>
              <td><multiselect v-model="watch.school_type" :options="school_type" label="name" :searchable="false" :show-labels="false" placeholder="公/国/私"></multiselect></td>
            </tr>
            <tr>
              <th>学校名</th>
              <td><input type="text" v-model="student.school_name" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>学年</th>
              <td><div class="calc">{{calcGrade}}</div></td>
            </tr>
            <tr>
              <th>留年・浪人</th>
              <td><input type="number" v-model="student.grade_flag" placeholder="留年・浪人" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>指導詳細</th>
              <td><input type="text" v-model="student.guidance_detail" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>次回引継時期</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="student.takeover_time" placeholder="次回引継時期" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>引継結果</th>
              <td><multiselect v-model="watch.inheritance_result" :options="inheritance_result" label="name" :searchable="false" :show-labels="false" placeholder="引継結果"></multiselect></td>
            </tr>
            <tr>
              <th>次回TEL日</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="student.next_contact_date" placeholder="次回TEL日" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>優先度</th>
              <td><multiselect v-model="watch.priority" :options="priority" label="name" :searchable="false" :show-labels="false" placeholder="優先度"></multiselect></td>
            </tr>
            <tr>
              <th class="req">役務開始</th>
              <td><input type="text" required maxlength="10" minlength="10" v-model="student.service_period_start" placeholder="役務開始" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th class="req">役務終了</th>
              <td><input type="text" required maxlength="10" minlength="10" v-model="student.service_period_end" placeholder="役務終了" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>備考</th>
              <td><textarea v-model="student.note"></textarea></td>
            </tr>
          </table>
        </div>
        <div style="display: flex">
          <btn class="m-btn m-btn--default"><i class="fa fa-pencil-square-o"></i>更新</btn>
          <btn class="m-btn m-btn--default cancel" type="button" @click.native.prevent="cancelStudent(student)"><i class="fa fa-pencil-square-o"></i>キャンセル</btn>
        </div>
      </form>
    </template>

    <template v-if="student.id !== edit_id.student_id">
      <div class="m-box__inner">
        <table class="m-detail">
          <template v-if="!valid">
            <tr>
              <th>エラー</th>
              <td class="errors"><div>{{errors}}が入力されていません</div></td>
            </tr>
          </template>
          <!-- <tr> -->
          <!--   <th>ID</th> -->
          <!--   <td>{{student.id}}</td> -->
          <!-- </tr> -->
          <!-- <tr> -->
          <!--   <th>family_id</th> -->
          <!--   <td>{{student.family_id}}</td> -->
          <!-- </tr> -->
          <!-- <tr> -->
          <!--   <th>user_id</th> -->
          <!--   <td>{{student.user_id}}</td> -->
          <!-- </tr> -->
          <tr>
            <th>状態</th>
            <td v-if="student.state === 0">未選択</td>
            <td v-if="student.state === 1">指導中</td>
            <td v-if="student.state === 2">休止</td>
            <td v-if="student.state === 3">CXL</td>
            <td v-if="student.state === 4">終了</td>
          </tr>
          <tr>
            <th>名前</th>
            <td>{{student.f_name}} {{student.l_name}}</td>
          </tr>
          <tr>
            <th>かな</th>
            <td>{{student.f_name_kana}} {{student.l_name_kana}}</td>
          </tr>
          <tr>
            <th>性別</th>
            <td v-if="student.gender === 0">未選択</td>
            <td v-if="student.gender === 1">男</td>
            <td v-if="student.gender === 2">女</td>
          </tr>
          <tr>
            <th>生年月日</th>
            <td> {{student.birthday}}</td>
          </tr>
          <tr>
            <th>年齢</th>
            <td>{{calcAge}}</td>
          </tr>
          <tr>
            <th>公/国/私</th>
            <td v-if="student.school_type === 0">未選択</td>
            <td v-if="student.school_type === 1">公立</td>
            <td v-if="student.school_type === 2">国立</td>
            <td v-if="student.school_type === 3">私立</td>
            <td v-if="student.school_type === 4">その他</td>
          </tr>
          <tr>
            <th>学校名</th>
            <td>{{student.school_name}}</td>
          </tr>
          <tr>
            <th>学年</th>
            <td>{{calcGrade}}</td>
          </tr>
          <tr>
            <th>留年・浪人</th>
            <td>{{student.grade_flag}}</td>
          </tr>
          <tr>
            <th>指導詳細</th>
            <td>{{student.guidance_detail}}</td>
          </tr>
          <tr>
            <th>次回引継時期</th>
            <td>{{student.takeover_time}}</td>
          </tr>
          <tr>
            <th>引継結果</th>
            <td v-if="student.inheritance_result === 0"></td>
            <td v-if="student.inheritance_result === 1">成功</td>
            <td v-if="student.inheritance_result === 2">失敗</td>
            <td v-if="student.inheritance_result === 3">保留</td>
          </tr>
          <tr>
            <th>次回TEL日</th>
            <td>{{student.next_contact_date}}</td>
          </tr>
          <tr>
            <th>優先度</th>
            <td v-if="student.priority === 0">未選択</td>
            <td v-if="student.priority === 1">メイン</td>
            <td v-if="student.priority === 2">サブ</td>
          </tr>
          <tr>
            <th>役務開始</th>
            <td>{{student.service_period_start}}</td>
          </tr>
          <tr>
            <th>役務終了</th>
            <td>{{student.service_period_end}}</td>
          </tr>
          <tr>
            <th>備考</th>
            <td style="white-space: pre-wrap">{{student.note}}</td>
          </tr>
        </table>
      </div>
      <btn @click.native="edit(student)"><i class="fa fa-pencil-square-o"></i>編集</btn>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    student: Object,
    edit_id: Object
  },
  data () {
    return {
      dtp: {
        // date: '',
        date: new Date(),
        format: 'yyyy/MM/dd',
        format2: 'yyyy/MM',
        disabled: {
          // to: new Date(2000, 4, 1)
          // from: new Date(2000, 4, 1)
          // days: [6, 0]
          // dates: [
          //   new Date(2017, 9, 16),
          //   new Date(2017, 9, 17),
          //   new Date(2017, 9, 18)
          // ]
        }
      },
      geometry: '',
      watch: {
        state: '',
        gender: '',
        school_type: '',
        priority: '',
        inheritance_result: ''
      },
      state: [
        { name: '未選択', value: 0 },
        { name: '指導中', value: 1 },
        { name: '休止', value: 2 },
        { name: 'CXL', value: 3 },
        { name: '終了', value: 4 }
      ],
      gender: [
        { name: '未選択', value: 0 },
        { name: '男', value: 1 },
        { name: '女', value: 2 }
      ],
      school_type: [
        { name: '未選択', valu: 0 },
        { name: '公立', value: 1 },
        { name: '国立', value: 2 },
        { name: '私立', value: 3 },
        { name: 'その他', value: 4 }
      ],
      priority: [
        { name: '未選択', value: 0 },
        { name: 'メイン', value: 1 },
        { name: 'サブ', value: 2 }
      ],
      inheritance_result: [
        { name: '', value: 0 },
        { name: '成功', value: 1 },
        { name: '失敗', value: 2 },
        { name: '保留', value: 3 }
      ]
    }
  },
  computed: {
    // validation
    f_name_kanaErrors: function () {
      return this.student.f_name_kana ? [] : ['せい']
    },
    l_name_kanaErrors: function () {
      return this.student.l_name_kana ? [] : ['めい']
    },
    genderErrors: function () {
      return this.student.gender ? [] : ['性別']
    },
    birthdayErrors: function () {
      return this.student.birthday ? [] : ['生年月日']
    },
    service_period_startErrors: function () {
      return this.student.service_period_start ? [] : ['役務開始']
    },
    service_period_endErrors: function () {
      return this.student.service_period_end ? [] : ['役務終了']
    },

    errors: function () {
      let errors = [].concat(
        this.f_name_kanaErrors,
        this.l_name_kanaErrors,
        this.genderErrors,
        this.birthdayErrors,
        this.service_period_startErrors,
        this.service_period_endErrors,
      )
      let errorsJoin = errors.join('・')
      // console.log(errorsJoin)
      return errorsJoin
    },
    valid: function () {
      return !this.errors
    },

    // age計算
    calcAge: function () {
      // console.log(this.student.birthday)
      let x = Date.parse(this.student.birthday) // 変換(ミリ秒が返される)
      let date = new Date(x) // ミリ秒をnew Dateに渡す
      let ageDifMs = Date.now() - date // 差分(ミリ秒)
      let ageDate = new Date(ageDifMs) // ミリ秒をnew Dateに渡す
      return ageDate.getUTCFullYear() - 1970
    },

    calcGrade: function () {
      let self = this

      // console.log(self.student.birthday)
      let x = Date.parse(self.student.birthday) // 変換(ミリ秒が返される)
      // console.log(x)
      let birthdate = new Date(x) // ミリ秒をnew Dateに渡す
      // console.log(birthdate)

      // ****/01/01-****/04/01の期間中は学年を上げない
      let year = new Date().getFullYear()
      if (new Date() >= new Date(new Date().getFullYear(), 0, 1) && new Date() <= new Date(new Date().getFullYear(), 3, 1, 23, 59)) {
        year = year - 1
      }
      // console.log(year)

      let ageNumber
      for (let i = 0; i < 100; i++) {
        if (birthdate >= new Date(year - i, 3, 2) && birthdate <= new Date(year - (i - 1), 3, 1, 23, 59)) {
          ageNumber = i
        }
      }

      // // 月だけ0から始まるので4月は3
      // let ageNumber
      // // 幼稚園年少 4年前/04/02-3年前/04/01
      // if (birthdate >= new Date(year - 4, 3, 2) && birthdate <= new Date(year - 3, 3, 1, 23, 59)) {
      //   ageNumber = 4
      //
      // // 幼稚園年中 5年前/04/02-4年前/04/01
      // } else if (birthdate >= new Date(year - 5, 3, 2) && birthdate <= new Date(year - 4, 3, 1, 23, 59)) {
      //   ageNumber = 5
      //
      // // 幼稚園年長 6年前/04/02-5年前/04/01
      // } else if (birthdate >= new Date(year - 6, 3, 2) && birthdate <= new Date(year - 5, 3, 1, 23, 59)) {
      //   ageNumber = 6
      //
      // // 小学1年生 7年前/04/02-6年前/04/01
      // } else if (birthdate >= new Date(year - 7, 3, 2) && birthdate <= new Date(year - 6, 3, 1, 23, 59)) {
      //   ageNumber = 7
      //
      // // 小学2年生 2009/04/02-2010/04/01
      // } else if (birthdate >= new Date(year - 8, 3, 2) && birthdate <= new Date(year - 7, 3, 1, 23, 59)) {
      //   ageNumber = 8
      //
      // // 小学3年生 2008/04/02-2009/04/01
      // } else if (birthdate >= new Date(year - 9, 3, 2) && birthdate <= new Date(year - 8, 3, 1, 23, 59)) {
      //   ageNumber = 9
      //
      // // 小学4年生 2007/04/02-2008/04/01
      // } else if (birthdate >= new Date(year - 10, 3, 2) && birthdate <= new Date(year - 9, 3, 1, 23, 59)) {
      //   ageNumber = 10
      //
      // // 小学5年生 2006/04/02-2007/04/01
      // } else if (birthdate >= new Date(year - 11, 3, 2) && birthdate <= new Date(year - 10, 3, 1, 23, 59)) {
      //   ageNumber = 11
      //
      // // 小学6年生 2005/04/02-2006/04/01
      // } else if (birthdate >= new Date(year - 12, 3, 2) && birthdate <= new Date(year - 11, 3, 1, 23, 59)) {
      //   ageNumber = 12
      //
      // // 中学1年生 2004/04/02-2005/04/01
      // } else if (birthdate >= new Date(year - 13, 3, 2) && birthdate <= new Date(year - 12, 3, 1, 23, 59)) {
      //   ageNumber = 13
      //
      // // 中学2年生 2003/04/02-2004/04/01
      // } else if (birthdate >= new Date(year - 14, 3, 2) && birthdate <= new Date(year - 13, 3, 1, 23, 59)) {
      //   ageNumber = 14
      //
      // // 中学3年生 2002/04/02-2003/04/01
      // } else if (birthdate >= new Date(year - 15, 3, 2) && birthdate <= new Date(year - 14, 3, 1, 23, 59)) {
      //   ageNumber = 15
      //
      // // 高校1年生 2001/04/02-2002/04/01
      // } else if (birthdate >= new Date(year - 16, 3, 2) && birthdate <= new Date(year - 15, 3, 1, 23, 59)) {
      //   ageNumber = 16
      //
      // // 高校2年生 2000/04/02-2001/04/01
      // } else if (birthdate >= new Date(year - 17, 3, 2) && birthdate <= new Date(year - 16, 3, 1, 23, 59)) {
      //   ageNumber = 17
      //
      // // 高校3年生 1999/04/02-2000/04/01
      // } else if (birthdate >= new Date(year - 18, 3, 2) && birthdate <= new Date(year - 17, 3, 1, 23, 59)) {
      //   ageNumber = 18
      //
      // // 未該当
      // } else {
      //   ageNumber = 0
      // }

      let gradeNumber = ageNumber + Number(self.student.grade_flag)
      // console.log(gradeNumber)

      // 月だけ0から始まるので4月は3
      let grade
      // 幼稚園年少 4年前/04/02-3年前/04/01
      if (gradeNumber === 4) {
        grade = '幼稚園年少'

      // 幼稚園年中 5年前/04/02-4年前/04/01
      } else if (gradeNumber === 5) {
        grade = '幼稚園年中'

      // 幼稚園年長 6年前/04/02-5年前/04/01
      } else if (gradeNumber === 6) {
        grade = '幼稚園年長'

      // 小学1年生 7年前/04/02-6年前/04/01
      } else if (gradeNumber === 7) {
        grade = '小学1年生'

      // 小学2年生 2009/04/02-2010/04/01
      } else if (gradeNumber === 8) {
        grade = '小学2年生'

      // 小学3年生 2008/04/02-2009/04/01
      } else if (gradeNumber === 9) {
        grade = '小学3年生'

      // 小学4年生 2007/04/02-2008/04/01
      } else if (gradeNumber === 10) {
        grade = '小学4年生'

      // 小学5年生 2006/04/02-2007/04/01
      } else if (gradeNumber === 11) {
        grade = '小学5年生'

      // 小学6年生 2005/04/02-2006/04/01
      } else if (gradeNumber === 12) {
        grade = '小学6年生'

      // 中学1年生 2004/04/02-2005/04/01
      } else if (gradeNumber === 13) {
        grade = '中学1年生'

      // 中学2年生 2003/04/02-2004/04/01
      } else if (gradeNumber === 14) {
        grade = '中学2年生'

      // 中学3年生 2002/04/02-2003/04/01
      } else if (gradeNumber === 15) {
        grade = '中学3年生'

      // 高校1年生 2001/04/02-2002/04/01
      } else if (gradeNumber === 16) {
        grade = '高校1年生'

      // 高校2年生 2000/04/02-2001/04/01
      } else if (gradeNumber === 17) {
        grade = '高校2年生'

      // 高校3年生 1999/04/02-2000/04/01
      } else if (gradeNumber === 18) {
        grade = '高校3年生'

      // 未該当
      } else {
        grade = ''
      }
      return grade
    }
    // gender2: {
    //   // getter 関数
    //   get: function () {
    //     console.log('get')
    //     if (this.student.gender.name) {
    //       console.log('nameあるやん')
    //     } else {
    //       console.log('うへっnameないやんけー')
    //       this.student.gender = { name: this.student.gender, value: this.student.gender }
    //     }
    //     return this.student.gender
    //   },
    //   // setter 関数
    //   set: function (gender) {
    //     console.log(this.gender2)
    //     this.student.gender = gender
    //   }
    // }
  },
  watch: {
    'watch.state': function (now, old) {
      // console.log(now)
      if (now) {
        this.student.state = now.value
      }
    },
    'watch.gender': function (now, old) {
      // console.log(now)
      if (now) {
        this.student.gender = now.value
      }
    },
    'watch.school_type': function (now, old) {
      // console.log(now)
      if (now) {
        this.student.school_type = now.value
      }
    },
    'watch.priority': function (now, old) {
      // console.log(now)
      if (now) {
        this.student.priority = now.value
      }
    },
    'watch.inheritance_result': function (now, old) {
      // console.log(now)
      if (now) {
        this.student.inheritance_result = now.value
      }
    }
  },
  methods: {
    edit: function (student) {
      this.watch.state = this.state[this.student.state]
      this.watch.gender = this.gender[this.student.gender]
      this.watch.school_type = this.school_type[this.student.school_type]
      this.watch.priority = this.priority[this.student.priority]
      this.watch.inheritance_result = this.inheritance_result[this.student.inheritance_result]
      this.edit_id.student_id = student.id
    },
    cancelStudent: function () {
      this.$store.dispatch('cancelStudent', {
        edit_id: this.edit_id
      })
    },
    patchStudent: function (student) {
      this.$store.dispatch('patchStudent', {
        this: this,
        geometry: this.geometry,
        student: student,
        edit_id: this.edit_id
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.errors {
  color: red;
  font-size: .85rem;
}
.req {
  background: #dffbef;
}
.fa-pencil-square-o {
  margin-right: 5px;
  font-weight: bold;
}
td {
  padding: 0 !important;
  height: 34px;
  input {
    width: 100%;
    font-size: 14px;
    border: none;
    height: 34px;
    &.name_w {
      width: 50%;
    }
    &:focus {
      color: #337bc4;
      font-weight: bold;
      border: solid 3px;
      outline: 0;
    }
  }
  textarea {
    width: 100%;
    font-size: 14px;
    border: none;
    height: 100px;
    &:focus {
      color: #337bc4;
      font-weight: bold;
      border: solid 3px;
      outline: 0;
    }
  }
  .calc {
    padding: 8px;
  }
}
.cancel {
  margin-top: 0 !important;
}
.fa-pencil {
  margin-right: 5px;
  font-weight: bold;
}
.m-box__inner {
  height: calc(100vh - 262px);
  overflow-y: scroll;
  border: 1px solid #eee;
}
</style>
<style lang="scss">
.StudentProfile {
  .multiselect {
    min-height: 26px;
  }
  .multiselect__tags {
    border: 0;
    min-height: 26px;
    padding: 0px 40px 0 2px;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 26px;
    font-size: 14px;
  }
  .multiselect__select {
    height: 26px;
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// StudentProfile.vue?0332674a